import { esc } from "../ui/format.js";
import { uiGet, uiMoney } from "../ui/kit.js";

/**
 * Richest people (World Ranking): you, the founder, among the world's
 * billionaires (backend/billionaires.py, Forbes' real-time list, names with
 * one letter removed). Your net worth is your stake: ownership x valuation.
 */
const prM = (v) => uiMoney(v, { compact: true });

function prLadder(r) {
  const you = r.you;
  const rows = [...r.above.map((p) => ({ ...p, kind: "them" })),
    { rank: you.world_rank || you.would_rank, name: `${you.name} (you)`, worth_usd: you.worth_usd, country: you.country || "", source: you.company, kind: "you" },
    ...r.below.map((p) => ({ ...p, rank: p.rank, kind: "them" }))];
  const max = Math.max(1, ...rows.map((x) => x.worth_usd));
  return `<div class="pr-ladder">${rows.map((x) => `
    <div class="pr-row ${x.kind}"><b>#${x.rank.toLocaleString("en-US")}</b><span>${esc(x.name)}<em>${esc(x.source || "")}${x.country ? ` · ${esc(x.country)}` : ""}</em></span>
      <i><u style="width:${(100 * x.worth_usd / max).toFixed(1)}%"></u></i><strong>${prM(x.worth_usd)}</strong></div>`).join("")}</div>`;
}

async function renderPeopleRankingInto(host) {
  const r = await uiGet("/people-ranking");
  const y = r.you;
  const onList = y.world_rank != null;
  host.innerHTML = `<div class="pr">
    <div class="pr-hero">
      <div class="pr-medal"><span>#</span>${(y.would_rank || 0).toLocaleString("en-US")}</div>
      <div><div class="sx-eyebrow">${onList ? "Your rank among the world's richest people" : "Where you'd rank among the world's richest people"}</div>
        <h3>${esc(y.name)}</h3>
        <p>Net worth <b>${prM(y.worth_usd)}</b>: your <b>${y.ownership_pct}%</b> of ${esc(y.company)} (valued at ${prM(y.company_valuation)}).</p>
        <p class="pr-sub">${y.is_billionaire ? "You're a billionaire." : `<b>${prM(r.to_billionaire_usd)}</b> more to become a billionaire.`}
          ${onList ? "" : ` The list starts at ${prM(r.list_cutoff_usd)}: <b>${prM(r.to_list_usd)}</b> to go.`}</p></div>
      <div class="pr-kpis">
        <div><span>World</span><b>#${(y.would_rank || 0).toLocaleString("en-US")}</b><em>of ${y.total.toLocaleString("en-US")}</em></div>
        ${y.country ? `<div><span>${esc(y.country)}</span><b>#${y.country_rank}</b><em>of ${y.country_total}</em></div>` : ""}
        ${y.industry ? `<div><span>${esc(y.industry)}</span><b>#${y.industry_rank}</b><em>of ${y.industry_total}</em></div>` : ""}
      </div>
    </div>
    <div class="pr-grid">
      <section><h4>Around you</h4>${prLadder(r)}</section>
      <section><h4>The world's 10 richest</h4><ol class="pr-top">${r.top.map((p) => `<li><b>#${p.rank}</b><span>${esc(p.name)}<em>${esc(p.source)} · ${esc(p.country)}</em></span><strong>${prM(p.worth_usd)}</strong></li>`).join("")}</ol></section>
    </div>
    <p class="pr-note">Real-time data: ${esc(r.data.source || "")} · ${r.data.count.toLocaleString("en-US")} people${r.data.fetched_at ? ` · updated ${esc(r.data.fetched_at.slice(0, 16).replace("T", " "))} UTC` : ""}${r.data.refreshing ? " · refreshing now…" : ""}. Names are shown with one letter removed.
      Your worth moves with your company's valuation and your ownership: every fundraise shrinks your stake.</p>
  </div>`;
}

window.renderPeopleRankingInto = renderPeopleRankingInto;

export { renderPeopleRankingInto };
